import { Api } from "../../Api";

import { githubApi } from "../../../github";

export const api: Api = {
  ...githubApi,
};
